import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-649634d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row lockHeader shinseisyoHeader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subheader col-md-6" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, " 文書詳細 ")
], -1))
const _hoisted_3 = {
  class: "subheader-block ml-auto demo col-md-6",
  style: {"text-align":"right"}
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-check mr-1" }, null, -1))
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-reply mr-1" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lockHeaderSpacer" }, "　", -1))
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "詳細情報"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_13 = { class: "panel-container show" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_15 = { class: "panel-content contents" }
const _hoisted_16 = {
  key: 0,
  class: "alert alert-secondary"
}
const _hoisted_17 = { class: "d-flex flex-start w-100" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mr-2 hidden-md-down" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon-stack icon-stack-lg" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
  ])
], -1))
const _hoisted_19 = { class: "d-flex flex-fill" }
const _hoisted_20 = { class: "flex-fill" }
const _hoisted_21 = {
  key: 0,
  class: "h5"
}
const _hoisted_22 = {
  key: 1,
  class: "h5"
}
const _hoisted_23 = { class: "m-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-external-link-square mr-1" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-external-link-square mr-1" }, null, -1))
const _hoisted_26 = { class: "row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "文書番号", -1))
const _hoisted_28 = { class: "col-md-10 contCnt" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "文書種別", -1))
const _hoisted_31 = { class: "col-md-10 contCnt" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "文書種類", -1))
const _hoisted_34 = { class: "col-md-10 contCnt" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "登録者", -1))
const _hoisted_38 = { class: "col-md-10 contCnt" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "金額", -1))
const _hoisted_41 = { class: "col-md-10 contCnt" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-12 contTitle",
  style: {"color":"rgb(190, 45, 45)"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "icon-stack icon-stack-lg",
    style: {"font-size":"21px"}
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fal fa-info-circle" })
  ]),
  /*#__PURE__*/_createTextVNode(" 金額は税込み金額を入力してください ")
], -1))
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "取引先", -1))
const _hoisted_46 = { class: "col-md-10 contCnt" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = { class: "row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "案件担当者", -1))
const _hoisted_50 = { class: "col-md-10 contCnt" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "発行年月日", -1))
const _hoisted_53 = { class: "col-md-10 contCnt" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "有効/無効", -1))
const _hoisted_56 = { class: "col-md-10 contCnt" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2 contTitle" }, "備考", -1))
const _hoisted_59 = { class: "col-md-10 contCnt" }
const _hoisted_60 = {
  id: "panel-4",
  class: "panel"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "関連案件"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_62 = { class: "panel-container show" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_64 = { class: "panel-content contents" }
const _hoisted_65 = { class: "" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = {
  class: "col-md-12",
  style: {"text-align":"right"}
}
const _hoisted_68 = ["disabled"]
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-plus mr-1" }, null, -1))
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { class: "list-group attendanceList" }
const _hoisted_72 = { class: "txt_excerpt" }
const _hoisted_73 = { style: {"border-top":"1px solid rgb(229, 229, 229)","padding-top":"10px","margin-top":"10px","text-align":"right"} }
const _hoisted_74 = { class: "btn-group btn-group-sm requestbtnFrame" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-external-link-square mr-1" }, null, -1))
const _hoisted_77 = ["onClick"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-plus mr-1" }, null, -1))
const _hoisted_79 = ["onClick"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-times mr-1" }, null, -1))
const _hoisted_81 = { key: 1 }
const _hoisted_82 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "変更履歴"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_84 = { class: "panel-container show" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_86 = {
  class: "panel-content contents",
  style: {"padding":"0"}
}
const _hoisted_87 = { class: "bg-subtlelight-fade custom-scroll" }
const _hoisted_88 = { class: "ml-3" }
const _hoisted_89 = {
  href: "javascript:void(0);",
  title: "Lisa Hatchensen",
  class: "d-block fw-700 text-dark"
}
const _hoisted_90 = { class: "col-lg-8" }
const _hoisted_91 = {
  id: "panel-1",
  class: "panel"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "panel-hdr" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "プレビュー"),
  /*#__PURE__*/_createElementVNode("div", { class: "panel-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-collapse",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Collapse"
    }),
    /*#__PURE__*/_createElementVNode("button", {
      class: "btn btn-panel",
      "data-action": "panel-fullscreen",
      "data-toggle": "tooltip",
      "data-offset": "0,10",
      "data-original-title": "Fullscreen"
    })
  ])
], -1))
const _hoisted_93 = { class: "panel-container show" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_95 = { class: "panel-content contents" }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-md-12 contCnt" }
const _hoisted_98 = { class: "btn-group btn-group-sm requestbtnFrame" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-upload mr-1" }, null, -1))
const _hoisted_101 = ["disabled"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-download mr-1" }, null, -1))
const _hoisted_103 = /*#__PURE__*/_createStaticVNode("<div class=\"btn-group btn-group-sm requestbtnFrame\" style=\"margin-left:5px;\" data-v-649634d6><button type=\"button\" class=\"btn btn-primary waves-effect waves-themed requestbtn\" disabled data-v-649634d6><span class=\"fal fa-undo mr-1\" data-v-649634d6></span></button><button type=\"button\" class=\"btn btn-primary waves-effect waves-themed requestbtn\" disabled data-v-649634d6><span class=\"fal fa-redo mr-1\" data-v-649634d6></span></button></div>", 1)
const _hoisted_104 = {
  class: "btn-group btn-group-sm requestbtnFrame",
  style: {"margin-left":"5px"}
}
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-search-plus mr-1" }, null, -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fal fa-search-minus mr-1" }, null, -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = {
  class: "row",
  id: "frame-kyuujitu",
  style: {"border-top":"1px solid rgb(229, 229, 229)","border-bottom":"1px solid rgb(229, 229, 229)","padding-top":"10px","margin-top":"10px"}
}
const _hoisted_110 = ["disabled", "onClick"]
const _hoisted_111 = { class: "thumlWrap" }
const _hoisted_112 = { class: "row" }
const _hoisted_113 = {
  key: 0,
  class: "text-right",
  style: {"margin-bottom":"10px"}
}
const _hoisted_114 = { class: "fileinfo fileinfo-name" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fileinfoTitle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-file-alt" }),
  /*#__PURE__*/_createTextVNode("ファイル名：")
], -1))
const _hoisted_116 = { class: "fileinfo fileinfo-ver" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fileinfoTitle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-code-branch" }),
  /*#__PURE__*/_createTextVNode("バージョン:")
], -1))
const _hoisted_118 = { class: "fileinfo fileinfo-size" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fileinfoTitle" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-expand-arrows-alt" }),
  /*#__PURE__*/_createTextVNode("サイズ：")
], -1))
const _hoisted_120 = { class: "col-md-12 contTitle" }
const _hoisted_121 = {
  id: "frame-img",
  style: {"box-shadow":"0 0 0.5cm rgba(0, 0, 0, 0.5)","margin":"0 auto","width":"80%","margin-top":"20px"}
}
const _hoisted_122 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","align-items":"center","max-width":"400px","width":"80%","height":"710px","margin":"0 auto"}
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", {
    style: {"text-align":"center","color":"#3b31a1"},
    class: "h2"
  }, " 画像読み込み中・・・ "),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/img/backgrounds/imgloading.svg",
      alt: "",
      style: {"width":"100%"}
    })
  ])
], -1))
const _hoisted_124 = [
  _hoisted_123
]
const _hoisted_125 = { class: "panel-container" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_127 = {
  key: 0,
  class: "fw-700 text-capitalize color-danger-300"
}
const _hoisted_128 = { style: {"width":"100%","height":"70vh","background-color":"white","border":"1px solid #e0e0e0"} }
const _hoisted_129 = { class: "panel-container" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1))
const _hoisted_131 = { style: {"width":"100%","height":"70vh","background-color":"white","border":"1px solid #e0e0e0"} }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-check-circle text-success mr-2" }, null, -1))
const _hoisted_133 = { class: "text-success fw-500" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_138 = { class: "modal-footer" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times-circle text-danger mr-2" }, null, -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_141 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!
  const _component_Mt_dtp = _resolveComponent("Mt_dtp")!
  const _component_Or_pdfviewer = _resolveComponent("Or_pdfviewer")!
  const _component_dropzone = _resolveComponent("dropzone")!
  const _component_Mo_modal_max_force = _resolveComponent("Mo_modal_max_force")!
  const _component_Mo_modal_l = _resolveComponent("Mo_modal_l")!
  const _component_Or_selectProject = _resolveComponent("Or_selectProject")!
  const _component_Or_selectSupply = _resolveComponent("Or_selectSupply")!
  const _component_Mo_modal_alert = _resolveComponent("Mo_modal_alert")!

  return (_openBlock(), _createElementBlock("main", {
    id: "js-page-content",
    role: "main",
    class: _normalizeClass(["page-content", {
      isEdit: _ctx.isEditMode,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              disabled: _ctx.btnDisable,
              class: "btn btn-primary waves-effect waves-themed",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.upd(false)))
            }, [
              _hoisted_5,
              _createTextVNode("登録 ")
            ], 8, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          disabled: _ctx.btnDisable,
          type: "button",
          class: "btn btn-secondary waves-effect waves-themed",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/doclist')))
        }, [
          _hoisted_7,
          _createTextVNode("戻る ")
        ], 8, _hoisted_6)
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              (
                  _ctx.delegate.c_claim_id != null ||
                  _ctx.delegate.c_request_expenses_id != null
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          (_ctx.delegate.c_request_expenses_id != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "この文書は経費精算書の領収書です"))
                            : _createCommentVNode("", true),
                          (_ctx.delegate.c_claim_id != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "この文書は当システムで発行された請求書です"))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_23, [
                            (_ctx.delegate.c_request_expenses_id != null)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn btn-primary waves-effect waves-themed",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo(_ctx.delegate.link4Expensess!, $event)))
                                }, [
                                  _hoisted_24,
                                  _createTextVNode("経費精算書 ")
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.delegate.c_claim_id != null)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "btn btn-primary waves-effect waves-themed",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo(_ctx.delegate.link4Claim!, $event)))
                                }, [
                                  _hoisted_25,
                                  _createTextVNode("請求書 ")
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKouzaCd",
                    class: "form-control form-control-sm",
                    disabled: "",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.delegate.c_doc_id) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.delegate.c_doc_id]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.op4DocManageType,
                    modelValue: _ctx.delegate.c_doc_managtype,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.delegate.c_doc_managtype) = $event)),
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createElementVNode("div", _hoisted_34, [
                  (
                      _ctx.delegate.c_claim_id != null ||
                      _ctx.delegate.c_request_expenses_id != null
                    )
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        name: "txtKouzaCd",
                        class: "form-control form-control-sm",
                        disabled: "",
                        value: _ctx.cnvDocType2Name()
                      }, null, 8, _hoisted_35))
                    : (_openBlock(), _createBlock(_component_vSelect, {
                        key: 1,
                        options: _ctx.op4DocType,
                        modelValue: _ctx.delegate.c_doc_type,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.delegate.c_doc_type) = $event)),
                        reduce: (label) => label.code
                      }, null, 8, ["options", "modelValue", "reduce"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKouzaCd",
                    class: "form-control form-control-sm",
                    disabled: "",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.domStaffName) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.domStaffName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createElementVNode("div", _hoisted_41, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKouzaCd",
                    class: "form-control form-control-sm",
                    disabled: 
                      _ctx.delegate.c_claim_id != null ||
                      _ctx.delegate.c_request_expenses_id != null
                    ,
                    onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.kanmaDel($event))),
                    onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.kanmaIns($event))),
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.domPrice) = $event))
                  }, null, 40, _hoisted_42), [
                    [_vModelText, _ctx.domPrice]
                  ]),
                  _hoisted_43
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "txtKouzaCd",
                    class: "form-control form-control-sm",
                    disabled: _ctx.delegate.c_claim_id != null,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.delegate.c_doc_customer) = $event))
                  }, null, 8, _hoisted_47), [
                    [_vModelText, _ctx.delegate.c_doc_customer]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.getOpStaffs(),
                    modelValue: _ctx.delegate.c_staff_id4project,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.delegate.c_staff_id4project) = $event)),
                    reduce: (label) => label.c_staff_id,
                    label: "c_staff_name"
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  _createVNode(_component_Mt_dtp, {
                    contdate: _ctx.domConsDate,
                    "onUpdate:contdate": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.domConsDate) = $event)),
                    holidays: _ctx.delegate4list,
                    "onUpdate:holidays": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.delegate4list) = $event)),
                    class: "notClear"
                  }, null, 8, ["contdate", "holidays"])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _createVNode(_component_vSelect, {
                    options: _ctx.opEnable,
                    modelValue: _ctx.delegate.c_doc_flag_enab,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.delegate.c_doc_flag_enab) = $event)),
                    label: "label",
                    reduce: (label) => label.code
                  }, null, 8, ["options", "modelValue", "reduce"])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _withDirectives(_createElementVNode("textarea", {
                    name: "txtComment",
                    class: "form-control heightup",
                    style: {"height":"150px"},
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.domRemarks) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.domRemarks]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _hoisted_61,
          _createElementVNode("div", _hoisted_62, [
            _hoisted_63,
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    (_ctx.isEditMode)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          disabled: _ctx.btnDisable,
                          class: "btn btn-primary waves-effect waves-themed",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showModal4Project()))
                        }, [
                          _hoisted_69,
                          _createTextVNode("関連案件を追加 ")
                        ], 8, _hoisted_68))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (_ctx.delegate.projects.length != 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      _createElementVNode("ul", _hoisted_71, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delegate.projects, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "list-group-item pro2dogRow",
                            key: item.c_project_id!
                          }, [
                            _createElementVNode("div", null, "受注番号：" + _toDisplayString(item.c_project_number), 1),
                            _createElementVNode("div", _hoisted_72, " 案件名：" + _toDisplayString(item.c_project_name), 1),
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary waves-effect waves-themed requestbtn",
                                  onClick: ($event: any) => (
                              _ctx.goTo(
                                '/jyutyuinput?record_id=' +
                                  item.c_project_number,
                                $event
                              )
                            )
                                }, [
                                  _hoisted_76,
                                  _createTextVNode(" 案件")
                                ], 8, _hoisted_75),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-primary waves-effect waves-themed requestbtn",
                                  onClick: ($event: any) => (_ctx.showModalSupply(item))
                                }, [
                                  _hoisted_78,
                                  _createTextVNode(" 請求No紐付 ")
                                ], 8, _hoisted_77),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-danger waves-effect waves-themed requestbtn",
                                  onClick: ($event: any) => (_ctx.delConf(item))
                                }, [
                                  _hoisted_80,
                                  _createTextVNode(" 関連解除 ")
                                ], 8, _hoisted_79)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_81, "文書に関連する案件はありません"))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_82, [
          _hoisted_83,
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                (
                    _ctx.delegate.items4History != null &&
                    _ctx.delegate.items4History.length > 0
                  )
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.delegate.items4History, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "d-flex flex-row px-3 pt-3 pb-2",
                        key: item.c_history_id!
                      }, [
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("a", _hoisted_89, _toDisplayString(_ctx.cnvLogdata2Str(item)), 1),
                          _createTextVNode(" " + _toDisplayString(item.c_history_det), 1)
                        ])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("更新履歴はありません")
                    ], 64))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_90, [
        _createElementVNode("div", _hoisted_91, [
          _hoisted_92,
          _createElementVNode("div", _hoisted_93, [
            _hoisted_94,
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed requestbtn",
                      disabled: 
                        _ctx.delegate.c_claim_id != null ||
                        _ctx.delegate.c_request_expenses_id != null
                      ,
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showModal4FileUpByUpd()))
                    }, [
                      _hoisted_100,
                      _createTextVNode(" アップロード")
                    ], 8, _hoisted_99),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed requestbtn",
                      disabled: _ctx.item4main.c_docfile_id == null,
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.dlFile()))
                    }, [
                      _hoisted_102,
                      _createTextVNode(" ダウンロード ")
                    ], 8, _hoisted_101)
                  ]),
                  _hoisted_103,
                  _createElementVNode("div", _hoisted_104, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed requestbtn",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.zoomIn()))
                    }, _hoisted_106),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary waves-effect waves-themed requestbtn",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.zoomOut()))
                    }, _hoisted_108)
                  ]),
                  _createElementVNode("div", _hoisted_109, [
                    (
                        _ctx.delegate.items4docFile != null &&
                        _ctx.delegate.items4docFile.length
                      )
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.delegate.items4docFile, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["thuml", {
                          isActiv: item.c_docfile_id == _ctx.item4main.c_docfile_id,
                        }]),
                            style: {"width":"10%"},
                            key: item.c_docfile_id!,
                            disabled: _ctx.btnDisable,
                            onClick: ($event: any) => (_ctx.chgMainImg(item))
                          }, [
                            _createElementVNode("div", _hoisted_111, [
                              _createVNode(_component_Or_pdfviewer, {
                                item: item,
                                isOne: true
                              }, null, 8, ["item"])
                            ])
                          ], 10, _hoisted_110))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_112, [
                (
                    _ctx.item4main.url4Show != null &&
                    _ctx.item4main.url4Show != '' &&
                    _ctx.showItem4main
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                      _createElementVNode("span", _hoisted_114, [
                        _hoisted_115,
                        _createTextVNode(_toDisplayString(_ctx.item4main.c_docfile_filename), 1)
                      ]),
                      _createElementVNode("span", _hoisted_116, [
                        _hoisted_117,
                        _createTextVNode(_toDisplayString(_ctx.item4main.c_docfile_ver), 1)
                      ]),
                      _createElementVNode("span", _hoisted_118, [
                        _hoisted_119,
                        _createTextVNode(_toDisplayString(_ctx.item4main.c_docfile_size), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_120, [
                  _createElementVNode("div", _hoisted_121, [
                    (
                        _ctx.item4main.url4Show != null &&
                        _ctx.item4main.url4Show != '' &&
                        _ctx.showItem4main
                      )
                      ? (_openBlock(), _createBlock(_component_Or_pdfviewer, {
                          key: 0,
                          item: _ctx.item4main
                        }, null, 8, ["item"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_122, _hoisted_124))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Mo_modal_max_force, { ref: "Mo_modal_fileup" }, {
      title: _withCtx(() => [
        _createTextVNode("ファイルアップロード")
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_125, [
          _hoisted_126,
          (!_ctx.isEditMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_127, " まずはファイルのアップロードから始めます... "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_128, [
            _createVNode(_component_dropzone, {
              fileInfo: _ctx.fileInfo,
              updateFileInfo: _ctx.updateFileInfo
            }, null, 8, ["fileInfo", "updateFileInfo"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-secondary waves-effect waves-themed",
              "data-dismiss": "modal",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.closeModal4FileUp()))
            }, " 閉じる "))
          : _createCommentVNode("", true),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-secondary waves-effect waves-themed",
              "data-dismiss": "modal",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$router.push('/doclist')))
            }, " 戻る "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_l, { ref: "Mo_modal_fileup4upd" }, {
      title: _withCtx(() => [
        _createTextVNode("ファイルアップロード")
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_129, [
          _hoisted_130,
          _createElementVNode("div", _hoisted_131, [
            _createVNode(_component_dropzone, {
              fileInfo: _ctx.fileInfo4Upd,
              updateFileInfo: _ctx.updateFileInfo4Upd
            }, null, 8, ["fileInfo", "updateFileInfo"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        (_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-secondary waves-effect waves-themed",
              "data-dismiss": "modal",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeModal4FileUpByUpd()))
            }, " 閉じる "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Or_selectProject, {
      ref: "comp_modal_project",
      docData: _ctx.delegate,
      "onUpdate:docData": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.delegate) = $event)),
      onModalclosed: _cache[26] || (_cache[26] = ($event: any) => (_ctx.get()))
    }, null, 8, ["docData"]),
    _createVNode(_component_Or_selectSupply, {
      ref: "Mo_modal_selectSupply",
      docData: _ctx.delegate,
      "onUpdate:docData": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.delegate) = $event)),
      proData: _ctx.entityProject4SelectSupply,
      "onUpdate:proData": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.entityProject4SelectSupply) = $event)),
      onModalclosed: _cache[29] || (_cache[29] = ($event: any) => (_ctx.get()))
    }, null, 8, ["docData", "proData"]),
    _createVNode(_component_Mo_modal_alert, {
      ref: "Mo_modal_success",
      onModalclosed: _cache[30] || (_cache[30] = ($event: any) => (_ctx.get()))
    }, {
      title: _withCtx(() => [
        _hoisted_132,
        _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.message4ModalSuccess), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_134
      ]),
      footer: _withCtx(() => [
        _hoisted_135
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_errorConf" }, {
      title: _withCtx(() => [
        _hoisted_136,
        _createTextVNode(_toDisplayString(_ctx.message4ModalErrorConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_137
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_138, [
          _createElementVNode("button", {
            onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.closeModal4ErrorConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " 確認 ")
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Mo_modal_alert, { ref: "Mo_modal_deleteConf" }, {
      title: _withCtx(() => [
        _hoisted_139,
        _createTextVNode(_toDisplayString(_ctx.message4ModalDelConf), 1)
      ]),
      body: _withCtx(() => [
        _hoisted_140
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_141, [
          _createElementVNode("button", {
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.del4Pro())),
            type: "button",
            class: "btn btn-danger shadow-0 bootbox-accept"
          }, " はい"),
          _createElementVNode("button", {
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.closeModal4deleteConf())),
            type: "button",
            class: "btn btn-default bootbox-cancel"
          }, " いいえ ")
        ])
      ]),
      _: 1
    }, 512)
  ], 2))
}